import axios from 'axios'

import { getRequestConfig } from '../api'

/**
 * Download a file via fetching the request as a blob. This is used to download things that require token to fetch
 * in a fashion where the token is not stored to browser history as it would be if we were simply to use an
 * url-parameter
 * @param url Address where the resource is located at
 * @param filename Name for the downloaded file including extension
 */
export function downloadFileFromURL(url: string, filename: string, headers: any = {}) {
  return new Promise<void>((resolve, reject) => {
    axios
      .get(url, {
        ...getRequestConfig({
          ...headers,
          'Content-Type': 'application/octet-stream',
        }),
        responseType: 'blob',
      })
      .then((response) => {
        downloadBlob(response?.data, filename)
        resolve()
      })
      .catch(() => {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject()
      })
  })
}

/**
 * Download contents of a blob to users computer with given filename
 * @param blob Contents of the file as blob
 * @param filename Name for the downloaded file including extension
 */
export function downloadBlob(blob: Blob, filename: string) {
  // MS Edge doesn't currently support filenames via download attribute so we need to do this
  if (typeof window?.navigator?.msSaveOrOpenBlob === 'function') {
    window?.navigator?.msSaveOrOpenBlob(blob, filename)
  } else {
    const fileUrl = window?.URL?.createObjectURL(blob)
    const link = document?.createElement('a')

    // Firefox requires all elements that are going to be clicked to have a place in DOM
    document?.body?.appendChild(link)
    link.href = fileUrl
    link.download = filename
    link.click()

    // Once the user has had sufficient time to download the file, lets clean out the dom element and object reference
    setTimeout(() => {
      document?.body?.removeChild(link)
      window?.URL?.revokeObjectURL(fileUrl)
    }, 20000)
  }
}
